import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { SerieInterface } from '../models/serie.interface';
import { Study } from '../models/study.interface';
import { GetStudiesReponse, GetStudyDetailsQuery, StudiesQuery, StudiesQueryVariables } from './studies.service';

@Injectable({
  providedIn: 'root'
})
export class SerieService {
  constructor(private readonly apollo: Apollo) { }

  getSeriesByStudy(studyId: number): Observable<SerieInterface[]> {
    return this.apollo.query<{ seriesByStudy: SerieInterface[] }>({
      query : gql`query getSerie($studyId: Long!) {
        seriesByStudy(studyId: $studyId) {
          id
          modalityTypeDescription
          studyName
          publicId
        }
      }`,
      variables: { studyId }
    }).pipe(map(res => res.data.seriesByStudy));
  }

  deleteSerie(serieId: number): Observable<Study | undefined> {
    return this.apollo.mutate<{ deleteSerie: Study }>({
      mutation: gql`mutation deleteSerie($serieId: Long!) {
        deleteSerie(serieId: $serieId) {
          id
        }
      }`,
      variables: {
        serieId
      },
      refetchQueries: [{
        query : GetStudyDetailsQuery,
        variables: { serieId }
      }],
      update: (store, { data }) => {
        if (data?.deleteSerie) {
          const studiesQuery = store.readQuery<GetStudiesReponse>({ query: StudiesQuery, variables: StudiesQueryVariables }) ;
          if (studiesQuery) {
            const studyId = data.deleteSerie.id;
            const listStudies = studiesQuery.studies;
            let listStudyItems = listStudies.items.map(s=> ({ ...s }));
            const studyFound = listStudyItems.find(s=>s.id === studyId);
            let totalCount = listStudies.totalCount;
            if (studyFound) {
              listStudyItems = listStudyItems.filter(s=> s.id !== studyId);
              totalCount--;
            }

            const newStudies = {
              studies : {
                items : listStudyItems,
                pageInfo : listStudies.pageInfo,
                totalCount
              }
            };
            store.writeQuery({ query: StudiesQuery, variables : StudiesQueryVariables, data : newStudies  });
          }
        }
      },
    }).pipe(map(res =>res.data ? res.data.deleteSerie : undefined));
  }
}
